import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {OrganizzazioniService} from '../../_services/organizzazioni.service';
import {AccountOrganizzazione} from '../../_models/AccountOrganizzazione';
import {SaveMessage} from '../../_helpers/save-message';

@Component({
    selector: 'app-ordini-viewmode-switch',
    templateUrl: './ordini-viewmode-switch.component.html',
    styleUrls: ['./ordini-viewmode-switch.component.scss'],
    standalone: false
})
export class OrdiniViewmodeSwitchComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  accountOrganizzazione: AccountOrganizzazione;
  loading = false;
  constructor(
    private saveMessage: SaveMessage,
    private organizzazioneService: OrganizzazioniService) { }

  ngOnInit() {
    this.accountOrganizzazione = this.organizzazioneService.currentAccountSettingsSubject.value;
    this.subscription = this.organizzazioneService.currentAccountSettingsSubject
      .subscribe((_accountOrg: AccountOrganizzazione) => {
        if (_accountOrg) {
          this.accountOrganizzazione = _accountOrg;
        }
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setViewMode = (viewGroup: boolean) => {
    this.loading = true;
    this.accountOrganizzazione.activeViewGroup = viewGroup;
    this.organizzazioneService.saveAccountOrganizzazioneAsync(this.accountOrganizzazione)
      .then((_accountOrg: AccountOrganizzazione) => {
        this.organizzazioneService.setCurrentAccountSettingsValue(_accountOrg);
      })
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il salvataggio."))
      .finally(() => this.loading = false);
  };
}
